import { useRef, useState } from "react";
import { useAtomValue } from "jotai";
import { Button } from "reactstrap";

import useUserSharedRecord from "../../../api/api-hooks/sharedRecords/useUserSharedRecord";
import useRecord from "../../../api/api-hooks/records/useRecord";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import SharedRecord from "./SharedRecord";
import AppDrawer from "../AppDrawer";

/**
 * Basic Share Record Drawer
 *
 * Doesn't include the Share Record Selectio.
 *
 */
export default function BasicSharedRecordDrawer({
  recordID,
  moduleAPIName,
  open,
  onClose,
}: {
  open: boolean;
  recordID: string;
  moduleAPIName: string;
  onClose: () => void;
}) {
  const sharedRecordRef = useRef<any>();
  const tenantID = useAtomValue(tenantIDAtom);
  const [disbaled, setDisabled] = useState(false);
  const { record } = useRecord({
    moduleAPIName: moduleAPIName,
    recordID: recordID,
  });
  const remoteRecord: any = record?._RemoteSystems?.find(
    (rs: any) => !!rs.RemoteRecordID
  );
  const { sharedRecord, expired } = useUserSharedRecord({
    recordID: remoteRecord?.RemoteID,
  });

  const handleOnClose = () => {
    onClose();
  };

  return (
    <AppDrawer
      open={open && !!sharedRecord}
      onClose={handleOnClose}
      headerTitle="Shared Record"
      headerOptions={
        <>
          {sharedRecord &&
            tenantID === sharedRecord.CloudID &&
            !remoteRecord?.SubViewRecord && (
              <Button
                style={{ width: 80 }}
                size="sm"
                color="primary"
                onClick={() => sharedRecordRef?.current()}
                disabled={disbaled}
              >
                Update
              </Button>
            )}
        </>
      }
      body={
        <SharedRecord
          recordID={recordID}
          recordModule={sharedRecord?.ModuleAPIName}
          globalAppID={sharedRecord?.GlobalAppID}
          sharedRecord={sharedRecord}
          expired={expired}
          sharedRecordRef={sharedRecordRef}
          setDisabled={setDisabled}
          defaulTab="SyncDetail"
          fromSubView={!!remoteRecord?.SubViewRecord}
          onClose={handleOnClose}
        />
      }
    />
  );
}
